export const TRANSFER_STEP_SESSION_KEY = 'offshore2go_onboarding_transfer_step';
/** Gravado no submit antes do setToken; lido uma vez no remount do AuthGuard. */
export const TRANSFER_STEP_PENDING_KEY = 'offshore2go_onboarding_transfer_step_pending';

/**
 * progress_step do backend exclusivo do wizard de transfer.
 * NÃO incluir 'summary' — esse valor também é usado no onboarding de nova offshore
 * e fazia guards redirecionarem create-from-scratch para /company-transfer.
 */
export const MID_TRANSFER_PROGRESS_STEPS = [
  'transfer_directors',
  'transfer_shareholders'
] as const;

export const clearTransferStepSession = () => {
  sessionStorage.removeItem(TRANSFER_STEP_SESSION_KEY);
  sessionStorage.removeItem(TRANSFER_STEP_PENDING_KEY);
};
